export default {
  en: {
    // Migrated from <i18n> SFC blocks (#6500)
    'recordscope-description': '1. Do you want the best record of all time?',
    'recordscope-yearly': 'Yearly',
    'recordscope-alltime': 'All Time',
    'year-selection': 'Please select a year',
    'filter-all-time-vs-yearly': 'All Time vs Yearly',
    'filter-time-frame': 'Time Frame',
    'filter-days-of-week': 'Days of Week',
    'filter-record-type': 'Record Type',
    'operation-metric-records-title': 'Records',
    'operation-metric-records-timeframe': 'Time frame',
    'operation-metric-records-timeframe-description': '2. Select the time frame',
    'operation-metric-records-weekframe-description': '3. Select the days of the week',
    'operation-metric-records-recordtype-description': '4. Select the best record type',
    // Migrated from <i18n> SFC blocks (#6500)
    'rbd-activation-insight-store-has-rbd': 'store has at least one RBD activated in the last 30 days but not completed',
    'rbd-activation-insight-stores-have-rbd': 'stores have at least one RBD activated in the last 30 days but not completed',
    'rbd-activation-more-info-store': 'Loc',
    'rbd-activation-more-info-more-info': 'More Info',
    // AOT grids
    'peaks': 'Peaks',
    'rank': 'Rank',
    // AOT column headers
    'dt-guest-count': 'DT Guest Count',
    'automation': 'Automation',
    'coverage': 'Coverage',
    'total-escalations': 'Total Escalations',
    'crew-escalation': 'Crew Escalation',
    'auto-escalation': 'Auto Escalation',
    'avg-order-taking-time': 'Avg Order Taking Time',
    'avg-oepe-wo-park': 'Avg OEPE W/O Park',
    'avg-oepe': 'Avg OEPE',
    'avg-service-time': 'Avg Service Time',
    'patch': 'Patch',
    'week-label': 'Week',
    'month-label': 'Month',
    // Daily Activity Report
    'daily-activity-report': 'Daily Activity Report',
    'daily-activity-report-analysis': 'Daily Activity Report Analysis',
    'service': 'Service',
    // Daily Glimpse
    'daily-glimpse': 'Daily Glimpse',
    // Find My Peak
    'find-my-peak': 'Find My Peak',
    'bad-quarter-hours': 'Bad quarter hours will be excluded from the peaks',
    'for-all-time-best': 'For all time best peaks, please try out our new',
    'records': 'Records',
    'report-for-various-sales-and-service-metrics': 'report for various Sales and Service metrics',
    'date-label': 'Date',
    'end-time': 'End Time',
    // MetricPeakSelector
    'highest': 'Highest',
    'lowest': 'Lowest',
    'items': 'Items',
    // QtrHrSwitch
    'hour': 'Hour',
    'qtr-hr': 'Qtr Hr',
    // Focus on Service
    'focus-on-service': 'Focus on Service',
    'focus-on-service-footer': '* Metrics are averaged by the number days',
    // Shared column headers (focusOnService / shiftManagerSummary)
    'all-net-sales': 'All Net Sales',
    'all-net-sales-comp': 'All Net Sales +/-',
    'average-check': 'Average Check',
    'average-check-comp': 'Average Check +/-',
    'act-vs-need': 'Act vs Need',
    'act-vs-sched': 'Act vs Sched',
    'punch-labor': 'Punch Labor',
    'punch-labor-pct': 'Punch Labor %',
    'dt-sales': 'DT Sales',
    'dt-sales-comp': 'DT Sales +/-',
    'dt-average-check': 'DT Average Check',
    'dt-average-check-comp': 'DT Average Check +/-',
    'oepe-wo-parked': 'OEPE W/O Parked',
    'oepe-wo-parked-comp': 'OEPE W/O Parked +/-',
    'dt-pulled-forward-pct': 'DT Pulled Forward %',
    'avg-ctp': 'Avg CTP',
    'avg-ctp-comp': 'Avg CTP +/-',
    'avg-dt-ttl': 'Avg DT TTL',
    'avg-dt-ttl-comp': 'Avg DT TTL +/-',
    'fc-all-net-sales': 'FC All Net Sales',
    'fc-sales-comp': 'FC Sales +/-',
    'fc-average-check': 'FC Average Check',
    'fc-average-check-comp': 'FC Average Check +/-',
    'in-store-all-net-sales': 'In-Store All Net Sales',
    'in-store-sales-comp': 'In-Store Sales +/-',
    'in-store-gc': 'In-Store GC',
    'in-store-gc-comp': 'In-Store GC +/-',
    'in-store-average-check': 'In-Store Average Check',
    'in-store-average-check-comp': 'In-Store Average Check +/-',
    'kvs-healthy-usage': 'KVS Healthy Usage',
    'kvs-time-per-gc': 'KVS Time Per GC',
    'fc-total-time': 'FC Total Time',
    'fc-total-time-comp': 'FC Total Time +/-',
    'num-shifts': '# of Shifts',
    'manager-name': 'Manager Name',
    'manager-total': 'Manager Total',
    // Operation Metric Records
    'omr-title': 'Records',
    'weekframe': 'Week frame',
    'timeframe-description': '1. Select the time frame',
    'weekframe-description': '2. Select the days of the week',
    'recordtype-description': '3. Select the best record type',
    'timeframe-selection': 'Please select a specific time frame',
    'daypart': 'Daypart',
    'hourly': 'Hourly',
    'peak': 'Peak',
    'peak-breakfast': 'Breakfast',
    'peak-lunch': 'Lunch',
    'peak-dinner': 'Dinner',
    'overall': 'Total Day',
    'overall-timeframe': 'Total Day',
    'weekframe-overall': 'Sun-Sat',
    'weekframe-weekday': 'Mon-Thu',
    'weekframe-weekend': 'Fri-Sun',
    'recordtype-total': 'Total',
    'recordtype-hour': 'Hour',
    // OMR column groups
    'dt-transactions': 'DT Transactions',
    'kvs-sandwiches': 'KVS Sandwiches',
    'kvs-time': 'KVS Time',
    'oepe-no-parked': 'OEPE No Parked',
    'total-transactions': 'Total Transactions',
    'record-value': 'Value',
    // Operations by Punched
    'operations-by-punched': 'Punched Summary',
    'employee-category': 'Employee Category',
    'all': 'All',
    'crew': 'Crew',
    'shift': 'Shift',
    'manager': 'Manager',
    'no-manager': 'No Manager',
    'shift-manager': 'Shift/Manager',
    'premium-verbiage': 'Upgrade to our Premium Plan to unlock the {crew} reporting and leaderboard. Click {here} to learn about the benefits of Premium!',
    // Ops grids
    'controls': 'Controls',
    'controls-analysis': 'Controls Analysis',
    'over-short': 'Over/Short',
    't-red-before': 'T-Red Before',
    't-red-after': 'T-Red After',
    'pos-overrings': 'POS Overrings',
    'cash-refund': 'Cash Refund',
    'cashless-refund': 'Cashless Refund',
    'emp-meal': 'Emp Meal',
    'mgr-meal': 'Mgr Meal',
    'discount': 'Discount',
    'billable-sales': 'Billable Sales',
    'fob': 'FOB',
    'fob-analysis': 'FOB Analysis',
    'fob-footer-1': '* FOB data displays completed or current monthly values.',
    'fob-footer-2': '* A date range within a certain month will have that monthly total.',
    'fob-footer-3': "* A date range covering several months will include all month's totals.",
    'waste': 'Waste',
    'waste-category-breads': 'Breads',
    'waste-category-proteins': 'Proteins',
    'waste-category-eggs': 'Eggs',
    'waste-category-other': 'Other',
    'waste-entry': 'Waste Entry',
    'loading-items': 'Loading items...',
    'raw-waste': 'Raw Waste',
    'completed-waste': 'Completed Waste',
    'cancel': 'Cancel',
    'submit': 'Submit',
    'waste-search-placeholder': 'Search for items...',
    'waste-selected-items': 'Selected Items',
    'waste-unit-case': 'Case',
    'waste-unit-inner': 'Inner',
    'waste-unit-each': 'Each',
    'waste-total': 'Total:',
    'waste-total-raw': 'Total Raw:',
    'waste-total-completed': 'Total Completed:',
    'waste-total-all': 'Total Waste:',
    'waste-exceeds-hard-limit': 'Total exceeds the maximum allowed limit of {limit}',
    'waste-exceeds-soft-limit': 'Total exceeds the recommended limit of {limit}',
    'waste-donate': 'Donate',
    'waste-donate-label': 'Donate: {name}',
    'waste-donation-error-exceeds': 'Cannot exceed waste quantity ({max})',
    'waste-donation-error-minimum': 'Minimum donation amount is {min}',
    'waste-donation-error-increment': 'Donation must be in increments of {increment}',
    'sales-analysis': 'Sales Analysis',
    'total-activity': 'Total Activity',
    'delivery': 'Delivery',
    'eat-in': 'Eat In',
    'takeout': 'Takeout',
    'mobile': 'Mobile',
    'cashless': 'Cashless',
    'discounts': 'Discounts',
    'tax': 'Tax',
    'gift-cards': 'Gift Cards',
    'coupons': 'Coupons',
    'service-analysis': 'Service Analysis',
    'dt-line': 'DT Line',
    'parked-cars': 'Parked Cars',
    'kvs-prep-time': 'KVS Prep Time',
    'expeditor-time': 'Expeditor Time',
    'beverage-time': 'Beverage Time',
    // Peak Target and Tracking
    'peak-target-and-tracking': 'Peak Target and Tracking',
    'averaged-by-shifts': '* Metrics are averaged by the number of shifts worked',
    'in-store-sales': 'In-Store Sales',
    'net-sales': 'Net Sales',
    'net-gc': 'Net GC',
    'all-net-sales-prev-year': 'All Net Sales Prev Year',
    'dt-sales-prev-year': 'DT Sales Prev Year',
    'in-store-sales-prev-year': 'In-Store Sales Prev Year',
    'dt-gc-prev-year': 'DT GC Prev Year',
    'in-store-gc-prev-year': 'In-Store GC Prev Year',
    'gc-prev-year': 'GC Prev Year',
    // Rank
    'highlight-location': 'Highlight Location',
    'rank-error-message-a': "QSRSoft Rank is exclusively available to QSRSoft Premium subscribers. The QSRSoft Premium suite offers a range of powerful features to enhance restaurant operations, including QSRSoft Equipment Ticketing to streamline repair and maintenance processes with improved visibility, and numerous other operation tools designed to centralize restaurant operations and communications within the QSRSoft ecosystem. If you're interested in subscribing to QSRSoft Premium, click",
    'rank-error-message-b': '. For more information about QSRSoft Premium, please contact QSRSoft or your system administrator.',
    'location': 'Loc',
    // Shift Manager Summary
    'shift-manager-summary': 'Shift Manager Summary',
    'shift-manager-summary-analysis': 'Shift Manager Summary Analysis',
    // 3D Trend
    'three-d-trend': '3D Trend',
    'avg-four-weeks': 'Average of 4 last weeks',
    'mcdelivery-net-sales': 'McDelivery Net Sales',
    'mcdelivery-gc': 'McDelivery GC',
    'mcdelivery-average-check': 'McDelivery Average Check',
    'mop-curbside-sales': 'MOP Curbside Sales',
    'mop-curbside-gc': 'MOP Curbside GC',
    'mop-curbside-average-check': 'MOP Curbside Average Check',
    'mcdelivery-and-curbside-sales': 'McDelivery & Curbside Sales',
    'mcdelivery-and-curbside-gc': 'McDelivery & Curbside GC',
    'mcdelivery-and-curbside-average-check': 'McDelivery & Curbside Average Check',
    'pull-forward-gc': 'Pull Forward GC',
    // Time Slice Summary
    'start-time': 'Start Time',
    'standard': 'Standard',
    'overnight': 'Overnight',
    'time-slice-summary': 'Time Slice Summary',
    'in-store': 'In-Store',
    // Trends
    'trends': 'Trends',
    'missing-permissions': 'Missing Permissions',
    'trends-error-message-a': "QSRSoft Trends report is exclusive to QSRSoft Premium users. The QSRSoft Premium suite offers a range of powerful features to enhance restaurant operations, including QSRSoft Equipment Ticketing to streamline repair and maintenance processes with improved visibility, and numerous other operation tools designed to centralize restaurant operations and communications within the QSRSoft ecosystem. If you're interested in subscribing to QSRSoft Premium, click",
    'trends-error-message-b': '. For more information about QSRSoft Premium, please contact QSRSoft or your system administrator.',
    'ttm': 'TTM',
    'by-week': 'By Week',
    'view-segment-by': 'View Segment By',
    'by-total': 'By Total',
    'by-hour': 'By Hour',
    'by-quarter-hour': 'By Quarter Hour',
    'by-daypart': 'By Daypart',
    'by-peak': 'By Peak',
    'by-time-slice': 'By Timeslice',
    // multiClient/DailyActivityReport
    'health': 'Health',
    // total-sales used in multiClient SalesGrid
    'total-sales': 'Total Sales',
    // peakTargetAndTracking column descriptions
    'storewide-all-net-sales-desc': 'Storewide All Net Sales',
    'storewide-all-net-sales-prev-year-desc': 'Storewide All Net Sales Previous Year',
    'all-net-sales-comp-desc': 'All net sales compared to last year (trading or calendar day)',
    'dt-all-net-sales-desc': 'Drive Thru All Net Sales',
    'dt-sales-prev-year-desc': 'All drive thru net sales previous year',
    'dt-sales-comp-desc': 'All drive thru sales compared to last year (trading or calendar day)',
    'in-store-all-net-sales-desc': 'In-Store All Net Sales',
    'in-store-sales-prev-year-desc': 'All In-Store net sales previous year',
    'in-store-sales-comp-desc': 'All In-Store net sales compared to last year (trading or calendar day)',
    'dt-guest-count-desc': 'Drive Thru Guest Count',
    'dt-gc-prev-year-desc': 'Drive thru GC last year',
    'dt-gc-comp-desc': 'Drive thru GC compared to last year (trading or calendar day)',
    'in-store-guest-count-desc': 'In-Store Guest Count',
    'in-store-gc-prev-year-desc': 'In-Store GC last year',
    'in-store-gc-comp-desc': 'In-Store GC compared to last year (trading or calendar day)',
    'guest-count-desc': 'Guest Count',
    'gc-prev-year-desc': 'GC last year',
    'gc-comp-desc': 'GC compared to last year (trading or calendar day)',
    // focusOnService / shiftManagerSummary column descriptions
    'gc-comp-last-year-desc': 'Guest Count compared to last year',
    'avg-check-comp-desc': 'Average Check compared to last year',
    'dt-sales-comp-ly-desc': 'DT Sales compared to last year',
    'dt-gc-comp-ly-desc': 'DT GC compared to last year',
    'dt-avg-check-comp-desc': 'Drive Thru Average Check Compared to last year',
    'oepe-comp-desc': 'OEPE Compared to Last Year',
    'oepe-wo-parked-comp-desc': 'OEPE W/O Parked Compared to last year',
    'avg-ctp-comp-desc': 'Avg CTP compared to last year',
    'avg-dt-ttl-comp-desc': 'Avg DT TTL compared to last year',
    'fc-all-net-sales-comp-desc': 'FC All Net Sales Compared to last year',
    'fc-gc-this-vs-last-desc': 'FC GC this year minus FC GC last year',
    'fc-gc-comp-ly-desc': 'FC GC compared to last year',
    'fc-avg-check-comp-desc': 'FC Average Check this year minus FC Average Check last year',
    'r2p-comp-desc': 'R2P compared to last year',
    'fc-total-time-comp-desc': 'FC Total Time compared to last year',
    'in-store-all-net-sales-comp-desc': 'In-Store All Net Sales compared to Last Year',
    'in-store-gc-this-vs-last-desc': 'In-Store GC this year minus In-Store GC last year',
    'in-store-avg-check-comp-desc': 'In-Store Average Check this year minus In-Store Average Check last year',
  },
  es: {
    // Migrated from <i18n> SFC blocks (#6500)
    'recordscope-description': '1. ¿Desea el mejor registro de todos los tiempos?',
    'recordscope-yearly': 'Anual',
    'recordscope-alltime': 'Todos los tiempos',
    'year-selection': 'Por favor selecciona un año',
    'filter-all-time-vs-yearly': 'Todo el tiempo vs Anual',
    'filter-time-frame': 'Marco de tiempo',
    'filter-days-of-week': 'Días de la semana',
    'filter-record-type': 'Tipo de registro',
    'operation-metric-records-title': 'Registros',
    'operation-metric-records-timeframe': 'Marco de tiempo',
    'operation-metric-records-timeframe-description': '2. Seleccione el marco de tiempo',
    'operation-metric-records-weekframe-description': '3. Seleccione los días de la semana',
    'operation-metric-records-recordtype-description': '4. Seleccione el mejor tipo de registro',
    // Migrated from <i18n> SFC blocks (#6500)
    'rbd-activation-insight-store-has-rbd': 'tienda tiene al menos un RBD activado en los últimos 30 días pero no completado',
    'rbd-activation-insight-stores-have-rbd': 'tiendas tienen al menos un RBD activado en los últimos 30 días pero no completado',
    'rbd-activation-more-info-store': 'Ubicación',
    'rbd-activation-more-info-more-info': 'Más Información',
    // AOT grids
    'peaks': 'Picos',
    'rank': 'Rango',
    // AOT column headers
    'dt-guest-count': 'Conteo de invitados de DT',
    'automation': 'Automatización',
    'coverage': 'Cobertura',
    'total-escalations': 'Total de escalaciones',
    'crew-escalation': 'Escalación de equipo',
    'auto-escalation': 'Escalación automática',
    'avg-order-taking-time': 'Tiempo Promedio de Toma de Pedidos',
    'avg-oepe-wo-park': 'Promedio de OEPE sin parqueo',
    'avg-oepe': 'OEPE Promedio',
    'avg-service-time': 'Tiempo Promedio de Servicio',
    'patch': 'Parche',
    'week-label': 'Semana',
    'month-label': 'Mes',
    // Daily Activity Report
    'daily-activity-report': 'Informe de Actividad Diaria',
    'daily-activity-report-analysis': 'Informe de Análisis de Actividad Diaria',
    'service': 'Servicio',
    // Daily Glimpse
    'daily-glimpse': 'Vistazo Diario',
    // Find My Peak
    'find-my-peak': 'Encuentra Mi Pico',
    'bad-quarter-hours': 'Los cuartos de hora inválidos serán excluidos de los picos',
    'for-all-time-best': 'Para los mejores picos de todos los tiempos, prueba nuestro nuevo',
    'records': 'Registros',
    'report-for-various-sales-and-service-metrics': 'informe para varios métricas de Ventas y Servicio',
    'date-label': 'Fecha',
    'end-time': 'Hora de Fin',
    'view-segment-by': 'Ver segmento por',
    'by-total': 'Por total',
    'by-hour': 'Por hora',
    'by-quarter-hour': 'Por cuarto de hora',
    'by-daypart': 'Por parte del día',
    'by-peak': 'Por pico',
    'by-time-slice': 'Por segmento de tiempo',
    // MetricPeakSelector
    'highest': 'Más alto',
    'lowest': 'Más bajo',
    'items': 'Artículos',
    // QtrHrSwitch
    'hour': 'Hora',
    'qtr-hr': 'Cuarto Hora',
    // Focus on Service
    'focus-on-service': 'Centrarse en el Servicio',
    'focus-on-service-footer': '* Las métricas se promedian por el número de días',
    // Shared column headers (focusOnService / shiftManagerSummary)
    'all-net-sales': 'Ventas Netas Totales',
    'all-net-sales-comp': 'Ventas Netas Totales +/-',
    'average-check': 'Cheque Promedio',
    'average-check-comp': 'Cheque Promedio +/-',
    'act-vs-need': 'Act vs Necesario',
    'act-vs-sched': 'Act vs Programado',
    'punch-labor': 'Horas Marcadas Laborales',
    'punch-labor-pct': 'Porcentaje de Trabajo Marcado',
    'dt-sales': 'Ventas DT',
    'dt-sales-comp': 'Ventas DT +/-',
    'dt-average-check': 'Cheque Promedio DT',
    'dt-average-check-comp': 'Cheque Promedio DT +/-',
    'oepe-wo-parked': 'OEPE Sin Pedidos Estacionados',
    'oepe-wo-parked-comp': 'OEPE Sin Pedidos Estacionados +/-',
    'dt-pulled-forward-pct': 'Porcentaje de DT Adelantado',
    'avg-ctp': 'Promedio CTP',
    'avg-ctp-comp': 'Promedio CTP +/-',
    'avg-dt-ttl': 'Promedio DT TTL',
    'avg-dt-ttl-comp': 'Promedio DT TTL +/-',
    'fc-all-net-sales': 'Ventas FC All Net Sales',
    'fc-sales-comp': 'Ventas FC +/-',
    'fc-average-check': 'Cheque Promedio FC',
    'fc-average-check-comp': 'Cheque Promedio FC +/-',
    'in-store-all-net-sales': 'Ventas Totales en Tienda',
    'in-store-sales-comp': 'Ventas en Tienda +/-',
    'in-store-gc': 'GC en Tienda',
    'in-store-gc-comp': 'GC en Tienda +/-',
    'in-store-average-check': 'Cheque Promedio en Tienda',
    'in-store-average-check-comp': 'Cheque Promedio en Tienda +/-',
    'kvs-healthy-usage': 'Uso Saludable de KVS',
    'kvs-time-per-gc': 'Tiempo KVS por GC',
    'fc-total-time': 'Tiempo Total del Mostrador Frontal',
    'fc-total-time-comp': 'Tiempo Total del Mostrador Frontal +/-',
    'num-shifts': '# de Turnos',
    'manager-name': 'Nombre del Gerente',
    'manager-total': 'Total del Gerente',
    // Operation Metric Records
    'omr-title': 'Registros',
    'weekframe': 'Marco semanal',
    'timeframe-description': '1. Seleccione el marco de tiempo',
    'weekframe-description': '2. Seleccione los días de la semana',
    'recordtype-description': '3. Seleccione el mejor tipo de registro',
    'timeframe-selection': 'Por favor seleccione un marco de tiempo específico',
    'daypart': 'Parte del día',
    'hourly': 'Por hora',
    'peak': 'Pico',
    'peak-breakfast': 'Desayuno',
    'peak-lunch': 'Almuerzo',
    'peak-dinner': 'Cena',
    'overall': 'Día completo',
    'overall-timeframe': 'Día completo',
    'weekframe-overall': 'Dom-Sáb',
    'weekframe-weekday': 'Lun-Jue',
    'weekframe-weekend': 'Vie-Dom',
    'recordtype-total': 'Total',
    'recordtype-hour': 'Hora',
    // OMR column groups
    'dt-transactions': 'Transacciones DT',
    'kvs-sandwiches': 'Sándwiches KVS',
    'kvs-time': 'Tiempo KVS',
    'oepe-no-parked': 'OEPE Sin Estacionamiento',
    'total-transactions': 'Transacciones Totales',
    'record-value': 'Valor',
    // Operations by Punched
    'operations-by-punched': 'Resumen de Punched',
    'employee-category': 'Empleado Categoría',
    'all': 'Todos',
    'crew': 'Equipo',
    'shift': 'Turno',
    'manager': 'Gerente',
    'no-manager': 'Sin Gerente',
    'shift-manager': 'Turno/Gerente',
    'premium-verbiage': '¡Actualice a nuestro Plan Premium para desbloquear el informe de {crew} y el tablero de líderes! Haga clic {here} para conocer los beneficios de Premium!',
    // Ops grids
    'controls': 'Controles',
    'controls-analysis': 'Análisis de Controles',
    'over-short': 'Sobrante/Falta',
    't-red-before': 'T-Red Antes',
    't-red-after': 'T-Red Después',
    'pos-overrings': 'Anulaciones POS',
    'cash-refund': 'Reembolso en Efectivo',
    'cashless-refund': 'Reembolso sin Efectivo',
    'emp-meal': 'Comida de Empleado',
    'mgr-meal': 'Comida de Gerente',
    'discount': 'Descuento',
    'billable-sales': 'Ventas Facturables',
    'fob': 'FOB',
    'fob-analysis': 'Análisis de FOB',
    'fob-footer-1': '* Los datos de FOB muestran valores mensuales completados o actuales.',
    'fob-footer-2': '* Un rango de fechas dentro de un cierto mes tendrá ese total mensual.',
    'fob-footer-3': '* Un rango de fechas que cubre varios meses incluirá los totales de todos los meses',
    'waste': 'Desperdicio',
    'waste-category-breads': 'Panes',
    'waste-category-proteins': 'Proteínas',
    'waste-category-eggs': 'Huevos',
    'waste-category-other': 'Otros',
    'waste-entry': 'Registro de Desperdicio',
    'loading-items': 'Cargando artículos...',
    'raw-waste': 'Desperdicio Crudo',
    'completed-waste': 'Desperdicio Completado',
    'cancel': 'Cancelar',
    'submit': 'Enviar',
    'waste-search-placeholder': 'Buscar artículos...',
    'waste-selected-items': 'Artículos Seleccionados',
    'waste-unit-case': 'Caja',
    'waste-unit-inner': 'Caja Interna',
    'waste-unit-each': 'Unidad',
    'waste-total': 'Total:',
    'waste-total-raw': 'Total Crudo:',
    'waste-total-completed': 'Total Completado:',
    'waste-total-all': 'Total Desperdicio:',
    'waste-exceeds-hard-limit': 'El total supera el límite máximo permitido de {limit}',
    'waste-exceeds-soft-limit': 'El total supera el límite recomendado de {limit}',
    'waste-donate': 'Donar',
    'waste-donate-label': 'Donar: {name}',
    'waste-donation-error-exceeds': 'No puede exceder la cantidad de desperdicio ({max})',
    'waste-donation-error-minimum': 'La cantidad mínima de donación es {min}',
    'waste-donation-error-increment': 'La donación debe ser en incrementos de {increment}',
    'sales-analysis': 'Análisis de Ventas',
    'total-activity': 'Actividad Total',
    'delivery': 'Entrega',
    'eat-in': 'Comer en el Local',
    'takeout': 'Para Llevar',
    'mobile': 'Móvil',
    'cashless': 'Sin Efectivo',
    'discounts': 'Descuentos',
    'tax': 'Impuestos',
    'gift-cards': 'Tarjetas de Regalo',
    'coupons': 'Cupones',
    'service-analysis': 'Análisis de Servicio',
    'dt-line': 'Línea de DT',
    'parked-cars': 'Autos Estacionados',
    'kvs-prep-time': 'Tiempo de Preparación de KVS',
    'expeditor-time': 'Tiempo de Expedidor',
    'beverage-time': 'Tiempo de Bebidas',
    // Peak Target and Tracking
    'peak-target-and-tracking': 'Objetivo Máximo y Seguimiento',
    'averaged-by-shifts': '* Las métricas se promedian por el número de turnos trabajados',
    'in-store-sales': 'Ventas en Tienda',
    'net-sales': 'Ventas Netas',
    'net-gc': 'GC Neto',
    'all-net-sales-prev-year': 'Ventas Netas Totales Año Anterior',
    'dt-sales-prev-year': 'Ventas DT Año Anterior',
    'in-store-sales-prev-year': 'Ventas en Tienda Año Anterior',
    'dt-gc-prev-year': 'Cuenta de Invitados de Drive Thru Año Anterior',
    'in-store-gc-prev-year': 'Cuenta de Invitados en Tienda Año Anterior',
    'gc-prev-year': 'Cuenta de Invitados Año Anterior',
    // Rank
    'highlight-location': 'Resaltar ubicación',
    'rank-error-message-a': 'QSRSoft Rank está disponible exclusivamente para suscriptores de QSRSoft Premium. La suite QSRSoft Premium ofrece una variedad de funciones potentes para mejorar las operaciones del restaurante, incluyendo QSRSoft Equipment Ticketing para agilizar los procesos de reparación y mantenimiento con mayor visibilidad, y muchas otras herramientas operativas diseñadas para centralizar las operaciones y comunicaciones del restaurante dentro del ecosistema QSRSoft. Si está interesado en suscribirse a QSRSoft Premium, haga clic',
    'rank-error-message-b': '. Para obtener más información sobre QSRSoft Premium, comuníquese con QSRSoft o con su administrador del sistema.',
    'location': 'Ubicación',
    // Shift Manager Summary
    'shift-manager-summary': 'Resumen del Jefe de Turno',
    'shift-manager-summary-analysis': 'Análisis del Resumen del Jefe de Turno',
    // 3D Trend
    'three-d-trend': 'Tendencias 3D',
    'avg-four-weeks': 'Promedio de las últimas 4 semanas',
    'mcdelivery-net-sales': 'Ventas Netas McDelivery',
    'mcdelivery-gc': 'GC McDelivery',
    'mcdelivery-average-check': 'Ticket Promedio McDelivery',
    'mop-curbside-sales': 'Ventas MOP en la Acera',
    'mop-curbside-gc': 'GC MOP en la Acera',
    'mop-curbside-average-check': 'Ticket Promedio MOP en la Acera',
    'mcdelivery-and-curbside-sales': 'Ventas McDelivery y Acera',
    'mcdelivery-and-curbside-gc': 'GC McDelivery y Acera',
    'mcdelivery-and-curbside-average-check': 'Ticket Promedio McDelivery y Acera',
    'pull-forward-gc': 'GC Avance Anticipado',
    // Time Slice Summary
    'start-time': 'Hora de Inicio',
    'standard': 'Estándar',
    'overnight': 'Nocturno',
    'time-slice-summary': 'Resumen de la Franja Horaria',
    'in-store': 'En la Local',
    // Trends
    'trends': 'Tendencias',
    'missing-permissions': 'Permisos Faltantes',
    'trends-error-message-a': 'El informe de tendencias de QSRSoft es exclusivo para usuarios de QSRSoft Premium. La suite QSRSoft Premium ofrece una variedad de funciones potentes para mejorar las operaciones del restaurante, incluyendo QSRSoft Equipment Ticketing para agilizar los procesos de reparación y mantenimiento con mayor visibilidad, y muchas otras herramientas operativas diseñadas para centralizar las operaciones y comunicaciones del restaurante dentro del ecosistema QSRSoft. Si está interesado en suscribirse a QSRSoft Premium, haga clic',
    'trends-error-message-b': '. Para obtener más información sobre QSRSoft Premium, comuníquese con QSRSoft o con su administrador del sistema.',
    'ttm': 'UDM',
    'by-week': 'Por semana',
    // multiClient/DailyActivityReport
    'health': 'Salud',
    // total-sales used in multiClient SalesGrid
    'total-sales': 'Ventas Totales',
    // peakTargetAndTracking column descriptions
    'storewide-all-net-sales-desc': 'Ventas Netas Totales de la Tienda',
    'storewide-all-net-sales-prev-year-desc': 'Ventas Netas Totales de la Tienda Año Anterior',
    'all-net-sales-comp-desc': 'Todas las ventas netas comparadas con el año anterior (día de intercambio o día calendario)',
    'dt-all-net-sales-desc': 'Ventas Netas Totales de Drive Thru',
    'dt-sales-prev-year-desc': 'Todas las ventas netas de drive thru del año anterior',
    'dt-sales-comp-desc': 'Todas las ventas de drive thru comparadas con el año anterior (día de intercambio o día calendario)',
    'in-store-all-net-sales-desc': 'Ventas Netas Totales en Tienda',
    'in-store-sales-prev-year-desc': 'Todas las ventas netas en tienda del año anterior',
    'in-store-sales-comp-desc': 'Todas las ventas en tienda comparadas con el año anterior (día de intercambio o día calendario)',
    'dt-guest-count-desc': 'Conteo de Visitantes de Drive Thru',
    'dt-gc-prev-year-desc': 'Conteo de visitantes de drive thru del año anterior',
    'dt-gc-comp-desc': 'Conteo de visitantes de drive thru comparado con el año anterior (día de intercambio o día calendario)',
    'in-store-guest-count-desc': 'Conteo de Visitantes en Tienda',
    'in-store-gc-prev-year-desc': 'Conteo de visitantes en tienda del año anterior',
    'in-store-gc-comp-desc': 'Conteo de visitantes en tienda comparado con el año anterior (día de intercambio o día calendario)',
    'guest-count-desc': 'Conteo de Visitantes',
    'gc-prev-year-desc': 'Conteo de visitantes del año anterior',
    'gc-comp-desc': 'Conteo de visitantes comparado con el año anterior (día de intercambio o día calendario)',
    // focusOnService / shiftManagerSummary column descriptions
    'gc-comp-last-year-desc': 'Conteo de visitantes comparado con el año anterior',
    'avg-check-comp-desc': 'Cheque promedio comparado con el año anterior',
    'dt-sales-comp-ly-desc': 'Ventas DT comparadas con el año anterior',
    'dt-gc-comp-ly-desc': 'Conteo de visitantes DT comparado con el año anterior',
    'dt-avg-check-comp-desc': 'Cheque promedio de Drive Thru comparado con el año anterior',
    'oepe-comp-desc': 'OEPE comparado con el año anterior',
    'oepe-wo-parked-comp-desc': 'OEPE sin autos estacionados comparado con el año anterior',
    'avg-ctp-comp-desc': 'CTP promedio comparado con el año anterior',
    'avg-dt-ttl-comp-desc': 'TTL DT promedio comparado con el año anterior',
    'fc-all-net-sales-comp-desc': 'Ventas netas totales de mostrador comparadas con el año anterior',
    'fc-gc-this-vs-last-desc': 'Conteo de visitantes de mostrador de este año menos el año anterior',
    'fc-gc-comp-ly-desc': 'Conteo de visitantes de mostrador comparado con el año anterior',
    'fc-avg-check-comp-desc': 'Cheque promedio de mostrador de este año menos el año anterior',
    'r2p-comp-desc': 'R2P comparado con el año anterior',
    'fc-total-time-comp-desc': 'Tiempo total de mostrador comparado con el año anterior',
    'in-store-all-net-sales-comp-desc': 'Ventas netas totales en tienda comparadas con el año anterior',
    'in-store-gc-this-vs-last-desc': 'Conteo de visitantes en tienda de este año menos el año anterior',
    'in-store-avg-check-comp-desc': 'Cheque promedio en tienda de este año menos el año anterior',
  },
  fr: {
    // Migrated from <i18n> SFC blocks (#6500)
    'recordscope-description': '1. Voulez-vous le meilleur record de tous les temps ?',
    'recordscope-yearly': 'Annuel',
    'recordscope-alltime': 'Tous les temps',
    'year-selection': 'Veuillez sélectionner une année',
    'filter-all-time-vs-yearly': 'Tous les temps vs annuel',
    'filter-time-frame': 'Période',
    'filter-days-of-week': 'Jours de la semaine',
    'filter-record-type': 'Type de record',
    'operation-metric-records-title': 'Records',
    'operation-metric-records-timeframe': 'Période',
    'operation-metric-records-timeframe-description': '2. Sélectionnez la période',
    'operation-metric-records-weekframe-description': '3. Sélectionnez les jours de la semaine',
    'operation-metric-records-recordtype-description': '4. Sélectionnez le meilleur type de record',
    // Migrated from <i18n> SFC blocks (#6500)
    'rbd-activation-insight-store-has-rbd': 'restaurant a au moins un RBD activé au cours des 30 derniers jours mais non finalisé',
    'rbd-activation-insight-stores-have-rbd': 'restaurants ont au moins un RBD activé au cours des 30 derniers jours mais non finalisé',
    'rbd-activation-more-info-store': 'Site',
    'rbd-activation-more-info-more-info': 'Plus d’informations',
    // AOT grids
    'peaks': 'Pointes',
    'rank': 'Classement',
    // AOT column headers
    'dt-guest-count': 'Nombre de clients Drive',
    'automation': 'Automatisation',
    'coverage': 'Couverture',
    'total-escalations': 'Total des escalades',
    'crew-escalation': 'Escalade équipier',
    'auto-escalation': 'Escalade automatique',
    'avg-order-taking-time': 'Temps moyen de prise de commande',
    'avg-oepe-wo-park': 'OEPE moyen hors mise en attente',
    'avg-oepe': 'OEPE moyen',
    'avg-service-time': 'Temps de service moyen',
    'patch': 'Correctif',
    'week-label': 'Semaine',
    'month-label': 'Mois',
    // Daily Activity Report
    'daily-activity-report': 'Rapport d’activité quotidienne',
    'daily-activity-report-analysis': 'Analyse du rapport d’activité quotidienne',
    'service': 'Service',
    // Daily Glimpse
    'daily-glimpse': 'Aperçu quotidien',
    // Find My Peak
    'find-my-peak': 'Trouver ma pointe',
    'bad-quarter-hours': 'Les quarts d’heure erronés seront exclus des pointes',
    'for-all-time-best': 'Pour les meilleures pointes de tous les temps, essayez notre nouveau rapport',
    'records': 'Records',
    'report-for-various-sales-and-service-metrics': 'pour divers indicateurs de ventes et de service',
    'date-label': 'Date',
    'end-time': 'Heure de fin',
    // MetricPeakSelector
    'highest': 'Le plus élevé',
    'lowest': 'Le plus bas',
    'items': 'Articles',
    // QtrHrSwitch
    'hour': 'Heure',
    'qtr-hr': 'Quart d’heure',
    // Focus on Service
    'focus-on-service': 'Focus service',
    'focus-on-service-footer': '* Les indicateurs sont moyennés sur le nombre de jours',
    // Shared column headers (focusOnService / shiftManagerSummary)
    'all-net-sales': 'Ventes nettes totales',
    'all-net-sales-comp': 'Ventes nettes totales +/-',
    'average-check': 'Ticket moyen',
    'average-check-comp': 'Ticket moyen +/-',
    'act-vs-need': 'Réel vs requis',
    'act-vs-sched': 'Réel vs planifié',
    'punch-labor': 'MO pointée',
    'punch-labor-pct': 'MO pointée %',
    'dt-sales': 'Ventes Drive',
    'dt-sales-comp': 'Ventes Drive +/-',
    'dt-average-check': 'Ticket moyen Drive',
    'dt-average-check-comp': 'Ticket moyen Drive +/-',
    'oepe-wo-parked': 'OEPE hors mise en attente',
    'oepe-wo-parked-comp': 'OEPE hors mise en attente +/-',
    'dt-pulled-forward-pct': '% avancés au Drive',
    'avg-ctp': 'CTP moyen',
    'avg-ctp-comp': 'CTP moyen +/-',
    'avg-dt-ttl': 'TTL Drive moyen',
    'avg-dt-ttl-comp': 'TTL Drive moyen +/-',
    'fc-all-net-sales': 'Ventes nettes totales comptoir',
    'fc-sales-comp': 'Ventes comptoir +/-',
    'fc-average-check': 'Ticket moyen comptoir',
    'fc-average-check-comp': 'Ticket moyen comptoir +/-',
    'in-store-all-net-sales': 'Ventes nettes totales en restaurant',
    'in-store-sales-comp': 'Ventes en restaurant +/-',
    'in-store-gc': 'GC en restaurant',
    'in-store-gc-comp': 'GC en restaurant +/-',
    'in-store-average-check': 'Ticket moyen en restaurant',
    'in-store-average-check-comp': 'Ticket moyen en restaurant +/-',
    'kvs-healthy-usage': 'Utilisation saine du KVS',
    'kvs-time-per-gc': 'Temps KVS par client',
    'fc-total-time': 'Temps total comptoir',
    'fc-total-time-comp': 'Temps total comptoir +/-',
    'num-shifts': 'Nb de postes',
    'manager-name': 'Nom du manager',
    'manager-total': 'Total manager',
    // Operation Metric Records
    'omr-title': 'Records',
    'weekframe': 'Jours de la semaine',
    'timeframe-description': '1. Sélectionnez la période',
    'weekframe-description': '2. Sélectionnez les jours de la semaine',
    'recordtype-description': '3. Sélectionnez le type de record',
    'timeframe-selection': 'Veuillez sélectionner une période précise',
    'daypart': 'Période de la journée',
    'hourly': 'Par heure',
    'peak': 'Pointe',
    'peak-breakfast': 'Petit-déjeuner',
    'peak-lunch': 'Déjeuner',
    'peak-dinner': 'Dîner',
    'overall': 'Journée entière',
    'overall-timeframe': 'Journée entière',
    'weekframe-overall': 'Dim-Sam',
    'weekframe-weekday': 'Lun-Jeu',
    'weekframe-weekend': 'Ven-Dim',
    'recordtype-total': 'Total',
    'recordtype-hour': 'Heure',
    // OMR column groups
    'dt-transactions': 'Transactions Drive',
    'kvs-sandwiches': 'Sandwiches KVS',
    'kvs-time': 'Temps KVS',
    'oepe-no-parked': 'OEPE sans mise en attente',
    'total-transactions': 'Total des transactions',
    'record-value': 'Valeur',
    // Operations by Punched
    'operations-by-punched': 'Synthèse des pointages',
    'employee-category': 'Catégorie d’employé',
    'all': 'Tous',
    'crew': 'Équipiers',
    'shift': 'Poste',
    'manager': 'Manager',
    'no-manager': 'Aucun manager',
    'shift-manager': 'Poste / manager',
    'premium-verbiage': 'Passez à notre offre Premium pour débloquer le reporting {crew} et le classement. Cliquez {here} pour découvrir les avantages de Premium !',
    // Ops grids
    'controls': 'Contrôles',
    'controls-analysis': 'Analyse des contrôles',
    'over-short': 'Excédent / manquant',
    't-red-before': 'T-Red avant',
    't-red-after': 'T-Red après',
    'pos-overrings': 'Surenregistrements caisse',
    'cash-refund': 'Remboursement espèces',
    'cashless-refund': 'Remboursement sans espèces',
    'emp-meal': 'Repas employé',
    'mgr-meal': 'Repas manager',
    'discount': 'Remise',
    'billable-sales': 'Ventes facturables',
    'fob': 'FOB',
    'fob-analysis': 'Analyse FOB',
    'fob-footer-1': '* Les données FOB affichent les valeurs mensuelles clôturées ou en cours.',
    'fob-footer-2': '* Une plage de dates comprise dans un même mois affichera le total de ce mois.',
    'fob-footer-3': '* Une plage de dates couvrant plusieurs mois inclura les totaux de tous ces mois.',
    'waste': 'Pertes',
    'waste-category-breads': 'Pains',
    'waste-category-proteins': 'Protéines',
    'waste-category-eggs': 'Œufs',
    'waste-category-other': 'Autres',
    'waste-entry': 'Saisie des pertes',
    'loading-items': 'Chargement des articles...',
    'raw-waste': 'Pertes brutes',
    'completed-waste': 'Pertes sur produits finis',
    'cancel': 'Annuler',
    'submit': 'Envoyer',
    'waste-search-placeholder': 'Rechercher des articles...',
    'waste-selected-items': 'Articles sélectionnés',
    'waste-unit-case': 'Caisse',
    'waste-unit-inner': 'Sous-emballage',
    'waste-unit-each': 'Unité',
    'waste-total': 'Total :',
    'waste-total-raw': 'Total brut :',
    'waste-total-completed': 'Total produits finis :',
    'waste-total-all': 'Total des pertes :',
    'waste-exceeds-hard-limit': 'Le total dépasse la limite maximale autorisée de {limit}',
    'waste-exceeds-soft-limit': 'Le total dépasse la limite recommandée de {limit}',
    'waste-donate': 'Faire un don',
    'waste-donate-label': 'Don : {name}',
    'waste-donation-error-exceeds': 'Ne peut pas dépasser la quantité perdue ({max})',
    'waste-donation-error-minimum': 'Le montant minimum du don est de {min}',
    'waste-donation-error-increment': 'Le don doit être un multiple de {increment}',
    'sales-analysis': 'Analyse des ventes',
    'total-activity': 'Activité totale',
    'delivery': 'Livraison',
    'eat-in': 'Sur place',
    'takeout': 'À emporter',
    'mobile': 'Mobile',
    'cashless': 'Sans espèces',
    'discounts': 'Remises',
    'tax': 'Taxes',
    'gift-cards': 'Cartes cadeaux',
    'coupons': 'Coupons',
    'service-analysis': 'Analyse du service',
    'dt-line': 'File Drive',
    'parked-cars': 'Voitures en attente',
    'kvs-prep-time': 'Temps de préparation KVS',
    'expeditor-time': 'Temps expéditeur',
    'beverage-time': 'Temps boissons',
    // Peak Target and Tracking
    'peak-target-and-tracking': 'Objectifs et suivi des pointes',
    'averaged-by-shifts': '* Les indicateurs sont moyennés sur le nombre de postes travaillés',
    'in-store-sales': 'Ventes en restaurant',
    'net-sales': 'Ventes nettes',
    'net-gc': 'GC net',
    'all-net-sales-prev-year': 'Ventes nettes totales année précédente',
    'dt-sales-prev-year': 'Ventes Drive année précédente',
    'in-store-sales-prev-year': 'Ventes en restaurant année précédente',
    'dt-gc-prev-year': 'GC Drive année précédente',
    'in-store-gc-prev-year': 'GC en restaurant année précédente',
    'gc-prev-year': 'GC année précédente',
    // Rank
    'highlight-location': 'Mettre le site en évidence',
    'rank-error-message-a': 'QSRSoft Rank est réservé aux abonnés QSRSoft Premium. La suite QSRSoft Premium offre de nombreuses fonctionnalités pour améliorer les opérations du restaurant, dont QSRSoft Equipment Ticketing pour fluidifier les processus de réparation et de maintenance avec une meilleure visibilité, ainsi que de nombreux autres outils conçus pour centraliser les opérations et la communication du restaurant dans l’écosystème QSRSoft. Si vous souhaitez souscrire à QSRSoft Premium, cliquez',
    'rank-error-message-b': '. Pour en savoir plus sur QSRSoft Premium, veuillez contacter QSRSoft ou votre administrateur système.',
    'location': 'Site',
    // Shift Manager Summary
    'shift-manager-summary': 'Synthèse du responsable de poste',
    'shift-manager-summary-analysis': 'Analyse de la synthèse du responsable de poste',
    // 3D Trend
    'three-d-trend': 'Tendance 3D',
    'avg-four-weeks': 'Moyenne des 4 dernières semaines',
    'mcdelivery-net-sales': 'Ventes nettes McDelivery',
    'mcdelivery-gc': 'GC McDelivery',
    'mcdelivery-average-check': 'Ticket moyen McDelivery',
    'mop-curbside-sales': 'Ventes MOP retrait en voiture',
    'mop-curbside-gc': 'GC MOP retrait en voiture',
    'mop-curbside-average-check': 'Ticket moyen MOP retrait en voiture',
    'mcdelivery-and-curbside-sales': 'Ventes McDelivery et retrait en voiture',
    'mcdelivery-and-curbside-gc': 'GC McDelivery et retrait en voiture',
    'mcdelivery-and-curbside-average-check': 'Ticket moyen McDelivery et retrait en voiture',
    'pull-forward-gc': 'GC avancés',
    // Time Slice Summary
    'start-time': 'Heure de début',
    'standard': 'Standard',
    'overnight': 'Nuit',
    'time-slice-summary': 'Synthèse par plage horaire',
    'in-store': 'En restaurant',
    // Trends
    'trends': 'Tendances',
    'missing-permissions': 'Autorisations manquantes',
    'trends-error-message-a': 'Le rapport QSRSoft Trends est réservé aux utilisateurs QSRSoft Premium. La suite QSRSoft Premium offre de nombreuses fonctionnalités pour améliorer les opérations du restaurant, dont QSRSoft Equipment Ticketing pour fluidifier les processus de réparation et de maintenance avec une meilleure visibilité, ainsi que de nombreux autres outils conçus pour centraliser les opérations et la communication du restaurant dans l’écosystème QSRSoft. Si vous souhaitez souscrire à QSRSoft Premium, cliquez',
    'trends-error-message-b': '. Pour en savoir plus sur QSRSoft Premium, veuillez contacter QSRSoft ou votre administrateur système.',
    'ttm': 'TTM',
    'by-week': 'Par semaine',
    'view-segment-by': 'Afficher le segment par',
    'by-total': 'Par total',
    'by-hour': 'Par heure',
    'by-quarter-hour': 'Par quart d’heure',
    'by-daypart': 'Par période de la journée',
    'by-peak': 'Par pointe',
    'by-time-slice': 'Par plage horaire',
    // multiClient/DailyActivityReport
    'health': 'Santé',
    // total-sales used in multiClient SalesGrid
    'total-sales': 'Ventes totales',
    // peakTargetAndTracking column descriptions
    'storewide-all-net-sales-desc': 'Ventes nettes totales sur l’ensemble du restaurant',
    'storewide-all-net-sales-prev-year-desc': 'Ventes nettes totales sur l’ensemble du restaurant l’année précédente',
    'all-net-sales-comp-desc': 'Ventes nettes totales comparées à l’an dernier (jour d’exploitation ou jour calendaire)',
    'dt-all-net-sales-desc': 'Ventes nettes totales du Drive',
    'dt-sales-prev-year-desc': 'Ventes nettes totales du Drive l’année précédente',
    'dt-sales-comp-desc': 'Ventes du Drive comparées à l’an dernier (jour d’exploitation ou jour calendaire)',
    'in-store-all-net-sales-desc': 'Ventes nettes totales en restaurant',
    'in-store-sales-prev-year-desc': 'Ventes nettes en restaurant l’année précédente',
    'in-store-sales-comp-desc': 'Ventes nettes en restaurant comparées à l’an dernier (jour d’exploitation ou jour calendaire)',
    'dt-guest-count-desc': 'Nombre de clients au Drive',
    'dt-gc-prev-year-desc': 'GC Drive l’an dernier',
    'dt-gc-comp-desc': 'GC Drive comparé à l’an dernier (jour d’exploitation ou jour calendaire)',
    'in-store-guest-count-desc': 'Nombre de clients en restaurant',
    'in-store-gc-prev-year-desc': 'GC en restaurant l’an dernier',
    'in-store-gc-comp-desc': 'GC en restaurant comparé à l’an dernier (jour d’exploitation ou jour calendaire)',
    'guest-count-desc': 'Nombre de clients',
    'gc-prev-year-desc': 'GC l’an dernier',
    'gc-comp-desc': 'GC comparé à l’an dernier (jour d’exploitation ou jour calendaire)',
    // focusOnService / shiftManagerSummary column descriptions
    'gc-comp-last-year-desc': 'Nombre de clients comparé à l’an dernier',
    'avg-check-comp-desc': 'Ticket moyen comparé à l’an dernier',
    'dt-sales-comp-ly-desc': 'Ventes Drive comparées à l’an dernier',
    'dt-gc-comp-ly-desc': 'GC Drive comparé à l’an dernier',
    'dt-avg-check-comp-desc': 'Ticket moyen du Drive comparé à l’an dernier',
    'oepe-comp-desc': 'OEPE comparé à l’an dernier',
    'oepe-wo-parked-comp-desc': 'OEPE hors mise en attente comparé à l’an dernier',
    'avg-ctp-comp-desc': 'CTP moyen comparé à l’an dernier',
    'avg-dt-ttl-comp-desc': 'TTL Drive moyen comparé à l’an dernier',
    'fc-all-net-sales-comp-desc': 'Ventes nettes totales comptoir comparées à l’an dernier',
    'fc-gc-this-vs-last-desc': 'GC comptoir de cette année moins GC comptoir de l’an dernier',
    'fc-gc-comp-ly-desc': 'GC comptoir comparé à l’an dernier',
    'fc-avg-check-comp-desc': 'Ticket moyen comptoir de cette année moins ticket moyen comptoir de l’an dernier',
    'r2p-comp-desc': 'R2P comparé à l’an dernier',
    'fc-total-time-comp-desc': 'Temps total comptoir comparé à l’an dernier',
    'in-store-all-net-sales-comp-desc': 'Ventes nettes totales en restaurant comparées à l’an dernier',
    'in-store-gc-this-vs-last-desc': 'GC en restaurant de cette année moins GC en restaurant de l’an dernier',
    'in-store-avg-check-comp-desc': 'Ticket moyen en restaurant de cette année moins ticket moyen en restaurant de l’an dernier',
  },
  'fr-ca': {
    // Migrated from <i18n> SFC blocks (#6500)
    'recordscope-description': '1. Voulez-vous le meilleur record de tous les temps?',
    'recordscope-yearly': 'Annuel',
    'recordscope-alltime': 'Tous les temps',
    'year-selection': 'Veuillez sélectionner une année',
    'filter-all-time-vs-yearly': 'Tous les temps vs annuel',
    'filter-time-frame': 'Période',
    'filter-days-of-week': 'Jours de la semaine',
    'filter-record-type': 'Type de record',
    'operation-metric-records-title': 'Records',
    'operation-metric-records-timeframe': 'Période',
    'operation-metric-records-timeframe-description': '2. Sélectionnez la période',
    'operation-metric-records-weekframe-description': '3. Sélectionnez les jours de la semaine',
    'operation-metric-records-recordtype-description': '4. Sélectionnez le meilleur type de record',
    // Migrated from <i18n> SFC blocks (#6500)
    'rbd-activation-insight-store-has-rbd': 'restaurant a au moins un RBD activé au cours des 30 derniers jours, mais non complété',
    'rbd-activation-insight-stores-have-rbd': 'restaurants ont au moins un RBD activé au cours des 30 derniers jours, mais non complété',
    'rbd-activation-more-info-store': 'Empl.',
    'rbd-activation-more-info-more-info': 'Plus de renseignements',
    // AOT grids
    'peaks': 'Périodes de pointe',
    'rank': 'Classement',
    // AOT column headers
    'dt-guest-count': 'Achalandage service au volant',
    'automation': 'Automatisation',
    'coverage': 'Couverture',
    'total-escalations': 'Total des escalades',
    'crew-escalation': 'Escalade équipier',
    'auto-escalation': 'Escalade automatique',
    'avg-order-taking-time': 'Temps moyen de prise de commande',
    'avg-oepe-wo-park': 'OEPE moyen sans stationnement',
    'avg-oepe': 'OEPE moyen',
    'avg-service-time': 'Temps de service moyen',
    'patch': 'Correctif',
    'week-label': 'Semaine',
    'month-label': 'Mois',
    // Daily Activity Report
    'daily-activity-report': 'Rapport d’activité quotidienne',
    'daily-activity-report-analysis': 'Analyse du rapport d’activité quotidienne',
    'service': 'Service',
    // Daily Glimpse
    'daily-glimpse': 'Coup d’œil quotidien',
    // Find My Peak
    'find-my-peak': 'Trouver ma période de pointe',
    'bad-quarter-hours': 'Les quarts d’heure erronés seront exclus des périodes de pointe',
    'for-all-time-best': 'Pour les meilleures pointes à vie, essayez notre nouveau rapport',
    'records': 'Records',
    'report-for-various-sales-and-service-metrics': 'pour divers indicateurs de ventes et de service',
    'date-label': 'Date',
    'end-time': 'Heure de fin',
    // MetricPeakSelector
    'highest': 'Le plus élevé',
    'lowest': 'Le plus bas',
    'items': 'Articles',
    // QtrHrSwitch
    'hour': 'Heure',
    'qtr-hr': 'Quart d’heure',
    // Focus on Service
    'focus-on-service': 'Focus sur le service',
    'focus-on-service-footer': '* Les indicateurs sont calculés en moyenne selon le nombre de jours',
    // Shared column headers (focusOnService / shiftManagerSummary)
    'all-net-sales': 'Ventes nettes totales',
    'all-net-sales-comp': 'Ventes nettes totales +/-',
    'average-check': 'Facture moyenne',
    'average-check-comp': 'Facture moyenne +/-',
    'act-vs-need': 'Réel c. requis',
    'act-vs-sched': 'Réel c. horaire',
    'punch-labor': 'Main-d’œuvre poinçonnée',
    'punch-labor-pct': 'Main-d’œuvre poinçonnée %',
    'dt-sales': 'Ventes service au volant',
    'dt-sales-comp': 'Ventes service au volant +/-',
    'dt-average-check': 'Facture moyenne service au volant',
    'dt-average-check-comp': 'Facture moyenne service au volant +/-',
    'oepe-wo-parked': 'OEPE sans stationnement',
    'oepe-wo-parked-comp': 'OEPE sans stationnement +/-',
    'dt-pulled-forward-pct': '% devancés au service au volant',
    'avg-ctp': 'CTP moyen',
    'avg-ctp-comp': 'CTP moyen +/-',
    'avg-dt-ttl': 'TTL moyen service au volant',
    'avg-dt-ttl-comp': 'TTL moyen service au volant +/-',
    'fc-all-net-sales': 'Ventes nettes totales comptoir',
    'fc-sales-comp': 'Ventes comptoir +/-',
    'fc-average-check': 'Facture moyenne comptoir',
    'fc-average-check-comp': 'Facture moyenne comptoir +/-',
    'in-store-all-net-sales': 'Ventes nettes totales en restaurant',
    'in-store-sales-comp': 'Ventes en restaurant +/-',
    'in-store-gc': 'GC en restaurant',
    'in-store-gc-comp': 'GC en restaurant +/-',
    'in-store-average-check': 'Facture moyenne en restaurant',
    'in-store-average-check-comp': 'Facture moyenne en restaurant +/-',
    'kvs-healthy-usage': 'Utilisation saine du KVS',
    'kvs-time-per-gc': 'Temps KVS par client',
    'fc-total-time': 'Temps total comptoir',
    'fc-total-time-comp': 'Temps total comptoir +/-',
    'num-shifts': 'Nb de quarts',
    'manager-name': 'Nom du gérant',
    'manager-total': 'Total gérant',
    // Operation Metric Records
    'omr-title': 'Records',
    'weekframe': 'Jours de la semaine',
    'timeframe-description': '1. Sélectionnez la période',
    'weekframe-description': '2. Sélectionnez les jours de la semaine',
    'recordtype-description': '3. Sélectionnez le type de record',
    'timeframe-selection': 'Veuillez sélectionner une période précise',
    'daypart': 'Période de la journée',
    'hourly': 'Par heure',
    'peak': 'Pointe',
    'peak-breakfast': 'Déjeuner',
    'peak-lunch': 'Dîner',
    'peak-dinner': 'Souper',
    'overall': 'Journée entière',
    'overall-timeframe': 'Journée entière',
    'weekframe-overall': 'Dim-Sam',
    'weekframe-weekday': 'Lun-Jeu',
    'weekframe-weekend': 'Ven-Dim',
    'recordtype-total': 'Total',
    'recordtype-hour': 'Heure',
    // OMR column groups
    'dt-transactions': 'Transactions service au volant',
    'kvs-sandwiches': 'Sandwichs KVS',
    'kvs-time': 'Temps KVS',
    'oepe-no-parked': 'OEPE sans stationnement',
    'total-transactions': 'Total des transactions',
    'record-value': 'Valeur',
    // Operations by Punched
    'operations-by-punched': 'Sommaire des poinçons',
    'employee-category': 'Catégorie d’employé',
    'all': 'Tous',
    'crew': 'Équipiers',
    'shift': 'Quart',
    'manager': 'Gérant',
    'no-manager': 'Aucun gérant',
    'shift-manager': 'Quart / gérant',
    'premium-verbiage': 'Passez à notre forfait Premium pour débloquer les rapports {crew} et le classement. Cliquez {here} pour découvrir les avantages de Premium!',
    // Ops grids
    'controls': 'Contrôles',
    'controls-analysis': 'Analyse des contrôles',
    'over-short': 'Excédent / manque',
    't-red-before': 'T-Red avant',
    't-red-after': 'T-Red après',
    'pos-overrings': 'Surenregistrements PDV',
    'cash-refund': 'Remboursement comptant',
    'cashless-refund': 'Remboursement sans comptant',
    'emp-meal': 'Repas employé',
    'mgr-meal': 'Repas gérant',
    'discount': 'Rabais',
    'billable-sales': 'Ventes facturables',
    'fob': 'FOB',
    'fob-analysis': 'Analyse FOB',
    'fob-footer-1': '* Les données FOB affichent les valeurs mensuelles complétées ou en cours.',
    'fob-footer-2': '* Une plage de dates comprise dans un même mois affichera le total de ce mois.',
    'fob-footer-3': '* Une plage de dates couvrant plusieurs mois inclura les totaux de tous ces mois.',
    'waste': 'Pertes',
    'waste-category-breads': 'Pains',
    'waste-category-proteins': 'Protéines',
    'waste-category-eggs': 'Œufs',
    'waste-category-other': 'Autres',
    'waste-entry': 'Saisie des pertes',
    'loading-items': 'Chargement des articles...',
    'raw-waste': 'Pertes brutes',
    'completed-waste': 'Pertes sur produits finis',
    'cancel': 'Annuler',
    'submit': 'Soumettre',
    'waste-search-placeholder': 'Rechercher des articles...',
    'waste-selected-items': 'Articles sélectionnés',
    'waste-unit-case': 'Caisse',
    'waste-unit-inner': 'Emballage intérieur',
    'waste-unit-each': 'Unité',
    'waste-total': 'Total :',
    'waste-total-raw': 'Total brut :',
    'waste-total-completed': 'Total produits finis :',
    'waste-total-all': 'Total des pertes :',
    'waste-exceeds-hard-limit': 'Le total dépasse la limite maximale permise de {limit}',
    'waste-exceeds-soft-limit': 'Le total dépasse la limite recommandée de {limit}',
    'waste-donate': 'Faire un don',
    'waste-donate-label': 'Don : {name}',
    'waste-donation-error-exceeds': 'Ne peut pas dépasser la quantité perdue ({max})',
    'waste-donation-error-minimum': 'Le montant minimal du don est de {min}',
    'waste-donation-error-increment': 'Le don doit être un multiple de {increment}',
    'sales-analysis': 'Analyse des ventes',
    'total-activity': 'Activité totale',
    'delivery': 'Livraison',
    'eat-in': 'Sur place',
    'takeout': 'Pour emporter',
    'mobile': 'Mobile',
    'cashless': 'Sans comptant',
    'discounts': 'Rabais',
    'tax': 'Taxes',
    'gift-cards': 'Cartes-cadeaux',
    'coupons': 'Coupons',
    'service-analysis': 'Analyse du service',
    'dt-line': 'File du service au volant',
    'parked-cars': 'Voitures stationnées',
    'kvs-prep-time': 'Temps de préparation KVS',
    'expeditor-time': 'Temps de l’expéditeur',
    'beverage-time': 'Temps des breuvages',
    // Peak Target and Tracking
    'peak-target-and-tracking': 'Cibles et suivi des périodes de pointe',
    'averaged-by-shifts': '* Les indicateurs sont calculés en moyenne selon le nombre de quarts travaillés',
    'in-store-sales': 'Ventes en restaurant',
    'net-sales': 'Ventes nettes',
    'net-gc': 'GC net',
    'all-net-sales-prev-year': 'Ventes nettes totales année précédente',
    'dt-sales-prev-year': 'Ventes service au volant année précédente',
    'in-store-sales-prev-year': 'Ventes en restaurant année précédente',
    'dt-gc-prev-year': 'GC service au volant année précédente',
    'in-store-gc-prev-year': 'GC en restaurant année précédente',
    'gc-prev-year': 'GC année précédente',
    // Rank
    'highlight-location': 'Mettre l’emplacement en évidence',
    'rank-error-message-a': 'QSRSoft Rank est offert exclusivement aux abonnés QSRSoft Premium. La suite QSRSoft Premium propose de nombreuses fonctionnalités pour améliorer les opérations du restaurant, dont QSRSoft Equipment Ticketing pour simplifier les processus de réparation et d’entretien avec une meilleure visibilité, ainsi que de nombreux autres outils conçus pour centraliser les opérations et les communications du restaurant dans l’écosystème QSRSoft. Si vous souhaitez vous abonner à QSRSoft Premium, cliquez',
    'rank-error-message-b': '. Pour en savoir plus sur QSRSoft Premium, veuillez communiquer avec QSRSoft ou votre administrateur système.',
    'location': 'Empl.',
    // Shift Manager Summary
    'shift-manager-summary': 'Sommaire du gérant de quart',
    'shift-manager-summary-analysis': 'Analyse du sommaire du gérant de quart',
    // 3D Trend
    'three-d-trend': 'Tendance 3D',
    'avg-four-weeks': 'Moyenne des 4 dernières semaines',
    'mcdelivery-net-sales': 'Ventes nettes McDelivery',
    'mcdelivery-gc': 'GC McDelivery',
    'mcdelivery-average-check': 'Facture moyenne McDelivery',
    'mop-curbside-sales': 'Ventes MOP ramassage en bordure',
    'mop-curbside-gc': 'GC MOP ramassage en bordure',
    'mop-curbside-average-check': 'Facture moyenne MOP ramassage en bordure',
    'mcdelivery-and-curbside-sales': 'Ventes McDelivery et ramassage en bordure',
    'mcdelivery-and-curbside-gc': 'GC McDelivery et ramassage en bordure',
    'mcdelivery-and-curbside-average-check': 'Facture moyenne McDelivery et ramassage en bordure',
    'pull-forward-gc': 'GC devancés',
    // Time Slice Summary
    'start-time': 'Heure de début',
    'standard': 'Standard',
    'overnight': 'Nuit',
    'time-slice-summary': 'Sommaire par plage horaire',
    'in-store': 'En restaurant',
    // Trends
    'trends': 'Tendances',
    'missing-permissions': 'Autorisations manquantes',
    'trends-error-message-a': 'Le rapport QSRSoft Trends est offert exclusivement aux utilisateurs QSRSoft Premium. La suite QSRSoft Premium propose de nombreuses fonctionnalités pour améliorer les opérations du restaurant, dont QSRSoft Equipment Ticketing pour simplifier les processus de réparation et d’entretien avec une meilleure visibilité, ainsi que de nombreux autres outils conçus pour centraliser les opérations et les communications du restaurant dans l’écosystème QSRSoft. Si vous souhaitez vous abonner à QSRSoft Premium, cliquez',
    'trends-error-message-b': '. Pour en savoir plus sur QSRSoft Premium, veuillez communiquer avec QSRSoft ou votre administrateur système.',
    'ttm': 'TTM',
    'by-week': 'Par semaine',
    'view-segment-by': 'Afficher le segment par',
    'by-total': 'Par total',
    'by-hour': 'Par heure',
    'by-quarter-hour': 'Par quart d’heure',
    'by-daypart': 'Par période de la journée',
    'by-peak': 'Par période de pointe',
    'by-time-slice': 'Par plage horaire',
    // multiClient/DailyActivityReport
    'health': 'Santé',
    // total-sales used in multiClient SalesGrid
    'total-sales': 'Ventes totales',
    // peakTargetAndTracking column descriptions
    'storewide-all-net-sales-desc': 'Ventes nettes totales pour l’ensemble du restaurant',
    'storewide-all-net-sales-prev-year-desc': 'Ventes nettes totales pour l’ensemble du restaurant l’année précédente',
    'all-net-sales-comp-desc': 'Ventes nettes totales comparées à l’an dernier (jour d’exploitation ou jour civil)',
    'dt-all-net-sales-desc': 'Ventes nettes totales du service au volant',
    'dt-sales-prev-year-desc': 'Ventes nettes totales du service au volant l’année précédente',
    'dt-sales-comp-desc': 'Ventes du service au volant comparées à l’an dernier (jour d’exploitation ou jour civil)',
    'in-store-all-net-sales-desc': 'Ventes nettes totales en restaurant',
    'in-store-sales-prev-year-desc': 'Ventes nettes en restaurant l’année précédente',
    'in-store-sales-comp-desc': 'Ventes nettes en restaurant comparées à l’an dernier (jour d’exploitation ou jour civil)',
    'dt-guest-count-desc': 'Achalandage du service au volant',
    'dt-gc-prev-year-desc': 'GC du service au volant l’an dernier',
    'dt-gc-comp-desc': 'GC du service au volant comparé à l’an dernier (jour d’exploitation ou jour civil)',
    'in-store-guest-count-desc': 'Achalandage en restaurant',
    'in-store-gc-prev-year-desc': 'GC en restaurant l’an dernier',
    'in-store-gc-comp-desc': 'GC en restaurant comparé à l’an dernier (jour d’exploitation ou jour civil)',
    'guest-count-desc': 'Achalandage',
    'gc-prev-year-desc': 'GC l’an dernier',
    'gc-comp-desc': 'GC comparé à l’an dernier (jour d’exploitation ou jour civil)',
    // focusOnService / shiftManagerSummary column descriptions
    'gc-comp-last-year-desc': 'Achalandage comparé à l’an dernier',
    'avg-check-comp-desc': 'Facture moyenne comparée à l’an dernier',
    'dt-sales-comp-ly-desc': 'Ventes du service au volant comparées à l’an dernier',
    'dt-gc-comp-ly-desc': 'GC du service au volant comparé à l’an dernier',
    'dt-avg-check-comp-desc': 'Facture moyenne du service au volant comparée à l’an dernier',
    'oepe-comp-desc': 'OEPE comparé à l’an dernier',
    'oepe-wo-parked-comp-desc': 'OEPE sans stationnement comparé à l’an dernier',
    'avg-ctp-comp-desc': 'CTP moyen comparé à l’an dernier',
    'avg-dt-ttl-comp-desc': 'TTL moyen du service au volant comparé à l’an dernier',
    'fc-all-net-sales-comp-desc': 'Ventes nettes totales comptoir comparées à l’an dernier',
    'fc-gc-this-vs-last-desc': 'GC comptoir de cette année moins GC comptoir de l’an dernier',
    'fc-gc-comp-ly-desc': 'GC comptoir comparé à l’an dernier',
    'fc-avg-check-comp-desc': 'Facture moyenne comptoir de cette année moins facture moyenne comptoir de l’an dernier',
    'r2p-comp-desc': 'R2P comparé à l’an dernier',
    'fc-total-time-comp-desc': 'Temps total comptoir comparé à l’an dernier',
    'in-store-all-net-sales-comp-desc': 'Ventes nettes totales en restaurant comparées à l’an dernier',
    'in-store-gc-this-vs-last-desc': 'GC en restaurant de cette année moins GC en restaurant de l’an dernier',
    'in-store-avg-check-comp-desc': 'Facture moyenne en restaurant de cette année moins facture moyenne en restaurant de l’an dernier',
  },
};
